import { FC } from 'react';

import { CoOwner } from 'types';

import { useTranslate } from 'hooks/useTranslate';
import ShareEncumbranceViewCoOwnersTable from './ShareEncumbranceViewCoOwnersTable';
import ShareEncumbranceViewCoOwnersForm from './ShareEncumbranceViewCoOwnersForm';
import { EncumbranceTypes } from '../constants/encumbranceOptions';
import { encumbranceCoOwnersConfig } from '../constants/encumbranceCoOwnersConfig';
import { CoOwnerViewProvider } from '../context/CoOwnerViewContext';

type Props = {
  mainCoOwner: CoOwner;
  coOwners: CoOwner[];
  encumbranceName: EncumbranceTypes;
  // eslint-disable-next-line no-unused-vars
  handleAddCoOwner: (coOwner: CoOwner) => void;
  // eslint-disable-next-line no-unused-vars
  handleRemoveCoOwner: (index: number) => void;
};

const ShareEncumbranceViewCoOwners: FC<Props> = ({
  mainCoOwner,
  coOwners,
  encumbranceName,
  handleAddCoOwner,
  handleRemoveCoOwner,
}) => {
  const { t } = useTranslate();

  const { sectionTitle } = encumbranceCoOwnersConfig[encumbranceName] || {
    sectionTitle: '',
  };

  const actualPercent = coOwners.reduce(
    (acc, coOwner) => acc + (coOwner.percent || 0),
    0
  );

  return (
    sectionTitle && (
      <>
        <CoOwnerViewProvider
          actualPercent={actualPercent}
          handleAddCoOwner={handleAddCoOwner}
        >
          <ShareEncumbranceViewCoOwnersForm encumbranceName={encumbranceName} />
        </CoOwnerViewProvider>

        {coOwners?.length > 0 && (
          <ShareEncumbranceViewCoOwnersTable
            mainCoOwner={mainCoOwner}
            coOwnersList={coOwners}
            handleRemoveCoOwner={handleRemoveCoOwner}
          />
        )}
      </>
    )
  );
};

export default ShareEncumbranceViewCoOwners;
